import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { AddToList } from '@thd-olt-component-react/add-to-list';
import { Heart, HeartFilled } from '@one-thd/sui-icons';
import { IconButton } from '@one-thd/sui-atomic-components';
import { SharebeltContext } from '../../Sharebelt.context';

const ShareBeltFavorite = ({ disable }) => {
  const { itemId } = useContext(SharebeltContext);
  const [iconFilled, setIconFilled] = useState(false);

  useEffect(() => {

    if (window.LIFE_CYCLE_EVENT_BUS) {
      const handleEvent = ({ output }) => {
        if (output.sku === itemId) {
          setIconFilled(true);
        }
      };

      window.LIFE_CYCLE_EVENT_BUS.on('save-to-favorites.track-add-item', handleEvent);
      window.LIFE_CYCLE_EVENT_BUS.on('save-to-favorites.create-a-list-with-item', handleEvent);
    }
  }, []);

  if (disable) {
    return null;
  }

  return (
    <AddToList
      itemId={itemId}
      quantity={1}
      CustomAddToListActionElement={({ onClick }) => (
        <IconButton
          aria-label="Add To List"
          size="large"
          icon={iconFilled ? HeartFilled : Heart}
          onClick={onClick}
        />
      )}
    />
  );
};

ShareBeltFavorite.displayName = 'ShareBeltFavorite';

ShareBeltFavorite.propTypes = {
  disable: PropTypes.bool,
};
ShareBeltFavorite.defaultProps = {
  disable: false,
};

ShareBeltFavorite.dataModel = extend({}, AddToList);

export default ShareBeltFavorite;